import {Route, Routes} from "react-router";
import React from "react";
import {MainPage} from "../main/MainPage";
import {BoardPage} from "../main/BoardPage";
import {SettingsPage} from "../main/SettingsPage";

export default function AppRouter(){

    return (
        <Routes>

            <Route index={true} element={<MainPage />} />
            <Route path={"board/:board/:year"} element={<BoardPage />} />
            <Route path={"settings"} element={<SettingsPage />} />

        </Routes>
    )

}